export default __webpack_public_path__ + "static/usdt-ae1267bcdb4121dbf8e0dc8e6ab61a5e.png";